/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelChargeCodeEdi.ts                 *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/charge-code-edi";

export class AutogenModelChargeCodeEdi<RowType extends ModelRow> extends Endpoint<RowType, RowChargeCodeEdiFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowChargeCodeEdi extends ModelRow<RowChargeCodeEdiFields> {
	constructor(values?: Partial<RowChargeCodeEdiFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowChargeCodeEdiFields {
	"charge_code.acct_int_id": string;
	"charge_code.acct_int_name": string;
	"charge_code.amount": number;
	"charge_code.charge_rate_method": string;
	"charge_code.co_amount": number;
	"charge_code.co_deduct_code_id": string;
	"charge_code.co_pay_method": string;
	"charge_code.co_payee_acct": string;
	"charge_code.co_percent": number;
	"charge_code.company_id": string;
	"charge_code.descr": string;
	"charge_code.edi_code": string;
	"charge_code.exclude_commissions": string;
	"charge_code.glid": string;
	"charge_code.id": string;
	"charge_code.incl_in_freight": string;
	"charge_code.is_fuel_surcharge": string;
	"charge_code.is_intermodal": string;
	"charge_code.is_taxable": string;
	"charge_code.is_tonu": string;
	"charge_code.ltl_allocation_method": string;
	"charge_code.oo_amount": number;
	"charge_code.oo_deduct_code_id": string;
	"charge_code.oo_pay_method": string;
	"charge_code.oo_payee_acct": string;
	"charge_code.oo_percent": number;
	"charge_code.pay_company_hourly_driver": string;
	"charge_code.prev_flag": string;
	"charge_code.rate": number;
	"charge_code.wf_min_charge": number;
	"charge_code.wf_occ_doctype": string;
	"charge_code.wf_occ_queue": string;
	"charge_code.who_to_pay": string;
	charge_code_id: string;
	company_id: string;
	edi_charge_code: string;
	id: string;
	partner_id: string;
	version: string;
}

